<mat-toolbar color="primary" class="action-toolbar">
    <h3>Coding</h3>
    <div class="toolbar-actions">
        <!-- Master Billing Editor Toggle Button -->
        <button mat-icon-button (click)="showMasterBillingEditor = !showMasterBillingEditor"
            [matTooltip]="showMasterBillingEditor ? 'Hide Master Billing Editor' : 'Show Master Billing Editor'">
            <mat-icon color="primary">{{ showMasterBillingEditor ? 'visibility_off' : 'edit' }}</mat-icon>
        </button>

        <!-- Status filter menu - available in both list and master-editor modes -->
        <button mat-icon-button [matMenuTriggerFor]="statusFilterMenu" matTooltip="Filter coding by status">
            <mat-icon [color]="statusFilters ? 'accent' : 'primary'">filter_list</mat-icon>
        </button>
        <mat-menu #statusFilterMenu="matMenu" class="filter-menu">
            <div mat-menu-content class="filter-menu-content" (click)="$event.stopPropagation()">
                <div class="filter-options">
                    <h4>Filter Coding</h4>
                    <mat-radio-group [(ngModel)]="statusFilters" class="status-filter-radios">
                        <mat-radio-button [value]="''">All</mat-radio-button>
                        <mat-radio-button *ngFor="let statusFilter of availableStatusFilters"
                            [value]="statusFilter.value">
                            {{ statusFilter.label }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </mat-menu>

        <!-- Export buttons - shown when not editing master billing -->
        <div *ngIf="!showMasterBillingEditor">
            <button mat-icon-button *ngIf="lastRangesInformation() as info" [matTooltip]="info"
                matTooltipClass="icd-tooltip"><mat-icon color="primary">info</mat-icon></button>
            <button mat-icon-button [matMenuTriggerFor]="exportMenu" *ngIf="!stateUnit"
                matTooltip="Export The Currently Filtered Coding List">
                <mat-icon color="primary">outgoing_mail</mat-icon>
            </button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="exportBilling('docx')">
                    <mat-icon>description</mat-icon>
                    <span>Export as Word</span>
                </button>
                <button mat-menu-item (click)="exportBilling('xlsx')">
                    <mat-icon>table_chart</mat-icon>
                    <span>Export as Excel</span>
                </button>
            </mat-menu>
            <button mat-icon-button *ngIf="connectFeatureEnabled && connectEnabled" (click)="submitBillingToSwitching()"
                matTooltip="Submit selected billing to Connect (switching platform)" [disabled]="isSubmitting">
                <mat-icon color="primary">cloud_upload</mat-icon>
            </button>
        </div>
    </div>
</mat-toolbar>

<!-- Inline Master Billing Editor - shown when toggled on -->
<app-inline-master-billing-editor *ngIf="showMasterBillingEditor" [filterValue]="filterValue"
    [statusFilters]="statusFilters">
</app-inline-master-billing-editor>

<!-- Existing billing view - shown when master billing editor is hidden -->
<div class="patient-list-container" *ngIf="!showMasterBillingEditor">
    <div class="filter-wrapper">
        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="filterValue" (keyup)="applyFilter($event)" placeholder="Search patients"
                #input>
            <mat-icon matSuffix *ngIf="!filterValue">search</mat-icon>
            <mat-icon matSuffix *ngIf="filterValue" (click)="filterValue = ''" class="clickable">close</mat-icon>
            <mat-hint>Search by name, surname, patient number, or diagnosis</mat-hint>
        </mat-form-field>

        <div class="filter-controls">
            <div class="filter-chips-row">
                <mat-chip-listbox [(ngModel)]="exportFilterValue" (change)="onExportFilterSelection($event.value)">
                    <mat-chip-option value="week">Last Week</mat-chip-option>
                    <mat-chip-option value="month">Last Month</mat-chip-option>
                    <mat-chip-option value="last" [disabled]="!exportOptions.lastBillingExportCreatedDate">From Last
                        Export</mat-chip-option>
                    <mat-chip-option value="submitted" *ngIf="showSubmissionRanges"
                        [disabled]="!lastSubmissionDate">From Last Submitted</mat-chip-option>
                    <mat-chip-option value="all">All Coding</mat-chip-option>
                </mat-chip-listbox>
            </div>

            <div class="control-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="exportOptions.startDate"
                        placeholder="DD/MM/YYYY" (dateChange)="loadBilling()" [max]="maxDate">
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="exportOptions.endDate"
                        placeholder="DD/MM/YYYY" (dateChange)="loadBilling()">
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>


    <mat-tab-group (selectedIndexChange)="onTabChange($event)" [selectedIndex]="selectedTabId" class="tab-group"
        matTabGroupGesture [swipeLimitWidth]="80" [connectEdges]="true">
        <mat-tab>
            <ng-template mat-tab-label>
                By Patient
            </ng-template>
            <app-by-patient-billing-list [filterValue]="filterValue" [statusFilters]="statusFilters"
                [dateRange]="exportOptions"></app-by-patient-billing-list>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                By Date
            </ng-template>
            <app-by-date-billing-list [filterValue]="filterValue" [statusFilters]="statusFilters"
                [dateRange]="exportOptions" #byDateBillingList></app-by-date-billing-list>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Alerts ({{totalAlerts || 0}})
            </ng-template>
            <app-billing-alert-list [filterValue]="filterValue"></app-billing-alert-list>
        </mat-tab>
    </mat-tab-group>

</div>